


















import { Component, Vue } from "vue-property-decorator";
import QuickMitsumoriContent from "@/components/QuickMitsumoriContent.vue";
@Component({
  components: { QuickMitsumoriContent }
})
export default class QuickMitsumori extends Vue {
  onUpdateQuickMitsumoriQrInfo() {
    this.$emit("onUpdateQuickMitsumoriQrInfo");
  }
  /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [START] */
  onConfirmExit() {
    this.$router.push({ name: "reservation" });
  }
  /** 2021-07-19 sh #6989 refactoring for quick mitsumori. [END] */
}
